import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setFilenameMode } from '../redux/slices/fixMetadataSlice';
import ToggleSwitch from './ToggleSwitch';

const FixFilenameSettings = () => {
    const dispatch = useDispatch();
    const { filenameMode } = useSelector((state) => state.fixMetadata);

    const prettifyOn = filenameMode === 'prettify' || filenameMode === 'both';
    const dbOn = filenameMode === 'fixFromDb' || filenameMode === 'both';

    const togglePrettify = (val) => {
        if (val && dbOn) dispatch(setFilenameMode('both'));
        else if (val) dispatch(setFilenameMode('prettify'));
        else if (dbOn) dispatch(setFilenameMode('fixFromDb'));
        else dispatch(setFilenameMode('none'));
    };

    const toggleDb = (val) => {
        if (val && prettifyOn) dispatch(setFilenameMode('both'));
        else if (val) dispatch(setFilenameMode('fixFromDb'));
        else if (prettifyOn) dispatch(setFilenameMode('prettify'));
        else dispatch(setFilenameMode('none'));
    };

    return (
        <div className="description-container loudness-settings-container">
            <div className="settings-container">
                <h4 className="title">Settings</h4>
            </div>
            <div className="filter-settings-separator" />
            <h4 className="title">Rename Options</h4>
            <div className="metadata-fields-container">
                <div className="metadata-fields-grid">
                    <div className="loudness-label-tooltip-container">
                        <ToggleSwitch
                            id="filenamePrettify"
                            checked={prettifyOn}
                            onChange={togglePrettify}
                            label="Prettify"
                            tooltip="Capitalize first letter of each word and strip leading track numbers (e.g. 01. artist - title → Artist - Title)"
                        />
                    </div>
                    <div className="loudness-label-tooltip-container">
                        <ToggleSwitch
                            id="filenameUseDb"
                            checked={dbOn}
                            onChange={toggleDb}
                            label="Use Database Names"
                            tooltip="Replace filename with the correct artist and title from the database when found"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FixFilenameSettings;
